<template>
  <div class="multiple-row-text" v-html="value" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MultipleRowText extends Vue {
  @Prop({ type: String, default: '' }) value;
}
</script>

<style scoped>
.multiple-row-text {
  white-space: pre-wrap;
  text-align: left;
}
</style>
